import React, { useEffect, useState } from 'react';
import './PollResults.scss';
import { Doughnut } from 'react-chartjs-2';
import GoogleMapReact from 'google-map-react';
import Geocode from "react-geocode";
import pinImage from '../../assets/icons/map-pin.svg'

Geocode.setApiKey("AIzaSyCFpl1bkNOdp3QJdcfoifiZGIGY7b7bEKE");

const AnyReactComponent = ({ text }) => <div><img src={pinImage} alt="pin"/></div>;



const PollResults = ({pollResults}) => {
    const [results, setResults] = useState(0);
    const [winner, setWinner] = useState({label: "", count: 0, lat: "", long: ""});
    const [long, setLong] = useState(0);
    const [lat, setLat] = useState(0);

    const defaultProps = {
        center: {
            lat: lat,
            lng: long
          },
        zoom: 15
      };

    const [data, setData] = useState({

        labels: [],
        datasets: [
          {
            label: '# of Votes',
            data: [],
            backgroundColor: [
              'rgba(218, 53, 47, 1)',
              'rgba(254, 104, 11, 1)',
              'rgba(238, 185, 2, 1)',
              'rgba(151, 204, 4, 1)',
              'rgba(45, 125, 210, 1)',
              'rgba(33, 41, 92, 1)',
            ],
            borderColor: [
              'rgba(218, 53, 47, 1)',
              'rgba(254, 104, 11, 1)',
              'rgba(238, 185, 2, 1)',
              'rgba(151, 204, 4, 1)',
              'rgba(45, 125, 210, 1)',
              'rgba(33, 41, 92, 1)',
            ],
            borderWidth: 1,
            legend: {
                position: "bottom",
                align: "start"
            }
          },
          
        ],
      });


    useEffect(() => {
        pollResults && pollResults.map(item => {
            
                if(winner.count < item.voters.length) {
                     return setWinner({
                        label: item.label,
                        count: item.voters.length,
                        lat: item.value.latitude,
                        long: item.value.longitude
                    })
                }
            })
        
    },[pollResults, winner.count])


    useEffect(() => {
        pollResults && pollResults.map(item => {
            
                
            setData(prevState => {
                    return {
                    ...prevState,
                    labels: [...prevState.labels, item.value.label],
                    datasets: [
                        {...prevState.datasets[0],
                        data: [...prevState.datasets[0].data, item.voters.length]}
                    ]
                    }
                })
                if(winner.count < item.voters.length) {
                     setWinner({
                        label: item.label,
                        count: item.voters.length,
                        lat: item.value.latitude,
                        long: item.value.longitude
                    })
                }
              return  setResults((prevState) => {
                    return prevState + item.voters.length
                })
            })
        
    },[pollResults])

    useEffect(() => {
        winner.label !== "" && Geocode.fromAddress(winner.label).then(
            response => {
              const { lat, lng } = response.results[0].geometry.location;
              setLat(lat);
              setLong(lng)
            },
            error => {
              console.error(error);
            }
          );
    }, [winner])
    return (
        <div className="poll-results">
            <div className="poll-results__title-container">
                <p className="poll-results__title">The winning option is ...</p>
                <p className="poll-results__subtitle">{winner.label.split(',')[0]}</p>
            </div>
            <div className="poll-results__graph-container">
            <Doughnut data={data}   
            
            options={{
                maintainAspectRatio: false,
                responsive: true,
                legend: {
                  position: 'bottom',
                  labels: {
                    boxWidth: 10
                  }}
            }}
            />
            </div>
            <div className="poll-results__calculations-container">
                <p className="poll-results__calculations-title">Results Breakdown</p>
                {pollResults && pollResults.map(poll => {
                    return <p className="poll-results__calculations" key={poll._id}>{poll.value.label} : {results === 0 ? "0%" : `${Math.round((poll.voters.length/results) * 100)}%`}</p>
                })}
            </div>
            <div className="poll-results__map-container">
            <div style={{ height: '50vh', width: '100%' }}>
        {lat !== 0 && <GoogleMapReact
          bootstrapURLKeys={{ key: "AIzaSyCFpl1bkNOdp3QJdcfoifiZGIGY7b7bEKE" }}
          defaultCenter={defaultProps.center}
          defaultZoom={defaultProps.zoom}
        >
          <AnyReactComponent
            lat={winner,lat}
            lng={winner.long}
            text={"My Text"}
          />
        </GoogleMapReact>}
      </div>
            </div>
        </div>
    );
};

export default PollResults;